/* Hairfall PDP — interactions.
   Progressive enhancement only: every section renders and is usable without JS. */
(function () {
  'use strict';

  // Each section loads this file; only wire things up once.
  if (window.__hfPdpBooted) return;
  window.__hfPdpBooted = true;

  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------------------------------------------------------------- dots */
  function bindRailDots(root) {
    root.querySelectorAll('[data-hf-rail]').forEach(function (rail) {
      var dotsId = rail.getAttribute('data-hf-rail');
      var dots = root.querySelector('[data-hf-dots="' + dotsId + '"]');
      if (!dots) return;
      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) { dots.hidden = true; return; }

      dots.innerHTML = items.map(function (_, i) {
        return '<button type="button" class="hf-dot' + (i === 0 ? ' is-active' : '') +
               '" aria-label="Go to slide ' + (i + 1) + '"></button>';
      }).join('');
      var buttons = Array.prototype.slice.call(dots.children);

      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          rail.scrollTo({ left: items[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
      });

      var raf;
      rail.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var mid = rail.scrollLeft + rail.clientWidth / 2;
          var best = 0, bestD = Infinity;
          items.forEach(function (el, i) {
            var c = el.offsetLeft - rail.offsetLeft + el.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = i; }
          });
          buttons.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
        });
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------ pack pick */
  function bindPacks(root) {
    root.querySelectorAll('[data-hf-packs]').forEach(function (group) {
      var buttons = group.querySelectorAll('[data-hf-variant]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-hf-variant');
          selectVariant(id);
        });
      });
    });
  }

  /* Broadcast the chosen variant to every pack group, the buy buttons and
     the sticky bar, and keep the URL in sync so a refresh/share preserves it. */
  function selectVariant(id) {
    if (!id) return;

    document.querySelectorAll('[data-hf-variant]').forEach(function (b) {
      b.classList.toggle('is-selected', b.getAttribute('data-hf-variant') === id);
      b.setAttribute('aria-pressed', b.getAttribute('data-hf-variant') === id ? 'true' : 'false');
    });

    document.querySelectorAll('input[data-hf-variant-input]').forEach(function (input) {
      input.value = id;
    });

    var src = document.querySelector('[data-hf-variant="' + id + '"]');
    if (src) {
      var price = src.getAttribute('data-hf-price') || '';
      var compare = src.getAttribute('data-hf-compare') || '';
      document.querySelectorAll('[data-hf-sticky-price]').forEach(function (el) { el.textContent = price; });
      document.querySelectorAll('[data-hf-sticky-compare]').forEach(function (el) {
        el.textContent = compare;
        el.hidden = !compare;
      });
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    } catch (e) { /* non-blocking */ }
  }

  /* ------------------------------------------------------------ tabs */
  function bindTabs(root) {
    root.querySelectorAll('[data-hf-tabs]').forEach(function (wrap) {
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      var bar = wrap.querySelector('[data-hf-progress]');
      if (!tabs.length) return;

      function activate(i) {
        tabs.forEach(function (t, n) {
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
          t.tabIndex = n === i ? 0 : -1;
        });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
        if (bar) bar.style.width = (((i + 1) / tabs.length) * 100) + '%';
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + tabs.length) % tabs.length;
          tabs[n].focus();
          activate(n);
        });
      });
      activate(0);
    });
  }

  /* ------------------------------------------------------------ copy code */
  function bindCopy(root) {
    root.querySelectorAll('[data-hf-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-hf-copy') || '';
        var done = function () {
          var prev = btn.textContent;
          btn.textContent = 'COPIED';
          btn.classList.add('is-copied');
          setTimeout(function () {
            btn.textContent = prev;
            btn.classList.remove('is-copied');
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
          document.body.removeChild(ta);
          done();
        }
      });
    });
  }

  /* ------------------------------------------------------------ video */
  function bindVideo(root) {
    root.querySelectorAll('[data-hf-video]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-hf-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = wrap.getAttribute('data-hf-video');
        var native = wrap.querySelector('video');
        if (native) {
          native.controls = true;
          native.play();
          btn.remove();
          return;
        }
        if (!src) return;
        var frame = document.createElement('iframe');
        frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        frame.setAttribute('title', wrap.getAttribute('data-hf-video-title') || 'Product video');
        wrap.innerHTML = '';
        wrap.appendChild(frame);
      });
    });
  }

  /* ------------------------------------------------------- FAQ (one open) */
  function bindFaq(root) {
    root.querySelectorAll('[data-hf-faq]').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('details'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    bindRailDots(root);
    bindPacks(root);
    bindTabs(root);
    bindCopy(root);
    bindVideo(root);
    bindFaq(root);

    // Respect ?variant= on load so shared links land on the right pack.
    try {
      var v = new URL(window.location.href).searchParams.get('variant');
      if (v && document.querySelector('[data-hf-variant="' + v + '"]')) selectVariant(v);
    } catch (e) { /* ignore */ }
  }

  onReady(function () { init(document); });

  // Theme editor: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
